import './App.css';
import { HydraAdmin, ResourceGuesser } from '@api-platform/admin';
import VideoEdit from './pages/VideoEdit';
import AudioEdit from "./pages/AudioEdit";
import {CourseList} from './pages/CourseList';
import {VideoList} from './pages/VideoList';
import {AudioList} from './pages/AudioList';
import {TrackList} from './pages/TrackList';
import {AudioCreate} from './pages/AudioCreate';
import {theme} from './theme/themeConfig';
import authProvider from "./auth/authProvider";
import dataProvider from "./auth/dataProvider";
import CustomLayout from './layout/CustomLayout';
import {Menu} from "react-admin";
import DashboardIcon from "@mui/icons-material/Dashboard";
import * as React from "react";


const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;

const App = () => (
    <>
    <HydraAdmin 
        entrypoint={entrypoint}
        theme={theme}
        layout={CustomLayout}
        authProvider={authProvider} 
        dataProvider={dataProvider}
        >
        {(authProvider.canSeeVideo()) && (
            <>
                <ResourceGuesser name="videos" edit={VideoEdit} list={VideoList} />
                <ResourceGuesser name="courses" list={CourseList}/>
            </>
        )}
        {(authProvider.canSeeAudio()) && (
            <>
                <ResourceGuesser name="audio" list={AudioList} edit={AudioEdit} create={AudioCreate}/>
            </>
        )}
        {(authProvider.isAdmin()) && (
            <>
                <ResourceGuesser name="tracks" list={TrackList}/>
            </>
        )}
    </HydraAdmin>
    </>
);

export default App;
